var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secure-section",class:{ [_vm.className]: _vm.className }},[_c('p',{staticClass:"title"},[_vm._v("\n    Safe and Secure checkout\n  ")]),_vm._v(" "),_c('div',{staticClass:"secure-icons"},[_c('IconNortonSecured',{staticClass:"icon-norton-secured"}),_vm._v(" "),_c('IconSecureStripe'),_vm._v(" "),_c('IconSecurePaypal')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }